import {
	containerCouponBarSX,
	discountCouponBarSX,
	linkCouponBarSX,
} from '@/components/blocks/DpLibrary/DpCouponBar/styles';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { UrlObject } from 'url';

type DpCouponBarProps = {
	name?: string;
	discount: string | number;
	expiration: string;
	button?: string;
	href?: string | UrlObject;
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	sx?: SxProps<Theme>;
};

/** Barra superior del cupón de recompra. Reemplaza la barra de promoción genérica. */
export const DpCouponBar = ({
	name,
	discount,
	expiration,
	button = 'Ver mi selección',
	href,
	onClick,
	sx,
}: DpCouponBarProps) => (
	<Box sx={combineSX([containerCouponBarSX, ...(Array.isArray(sx) ? sx : [sx])])}>
		<Typography component="span" fontSize="inherit">
			{name ? `${name}, tu ` : 'Tu '}
			<Typography component="strong" sx={discountCouponBarSX}>
				{`${discount} OFF`}
			</Typography>
			{` se va en ${expiration} · `}
		</Typography>
		<Linkable href={href} onClick={onClick} sx={linkCouponBarSX}>
			{`${button} →`}
		</Linkable>
	</Box>
);
